import axios from "axios";
import {MASTER_ITEM_DEFECT_LIST_URL} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_MASTER_ITEM_DEFECT_LIST = 'FETCH_MASTER_ITEM_DEFECT_LIST'
export const RECEIVE_MASTER_ITEM_DEFECT_LIST = 'RECEIVE_MASTER_ITEM_DEFECT_LIST'
export const FAILED_MASTER_ITEM_DEFECT_LIST = 'FAILED_MASTER_ITEM_DEFECT_LIST'

export function fetchDefectItem(_id, _idAdmOffice, _idReturnOrder, _idDisposalOrder, _idMasterItem, _idMasterInbound){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_MASTER_ITEM_DEFECT_LIST});
        axios({
            method: 'post',
            url: MASTER_ITEM_DEFECT_LIST_URL,
            headers: {
                Authorization: auth
            },
            data: {
                id: _id,
                id_administration_office: _idAdmOffice,
                id_return_order: _idReturnOrder,
                id_disposal_order: _idDisposalOrder,
                id_master_item: _idMasterItem,
                id_master_inbound: _idMasterInbound
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_MASTER_ITEM_DEFECT_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_MASTER_ITEM_DEFECT_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_MASTER_ITEM_DEFECT_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_MASTER_ITEM_DEFECT_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_MASTER_ITEM_DEFECT_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_MASTER_ITEM_DEFECT_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_MASTER_ITEM_DEFECT_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}